export enum TextPlaceholderType {
    kParagraphBreak = '\u000a', // 硬回车符(转ParagraphReturn)
    kLineBreak = '\u000b', // 软回车符
    kParagraphReturn = '\u000d', // 硬回车符
    kFieldBegin = '\u0013', // 域开始符
    kFieldEnd = '\u0015', // 域结束符
}
